import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "emailjs-com";
import "./Contact.css";
import { FaInstagram, FaEnvelope } from "react-icons/fa";
import Flag from "react-world-flags";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.message
    ) {
      setErrorMessage("Please fill in all required fields.");
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setErrorMessage("Please provide a valid email address.");
      return false;
    }
    if (!recaptchaToken) {
      setErrorMessage("Please complete the reCAPTCHA.");
      return false;
    }
    return true;
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (!validateForm()) return;

    const emailParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      subject: formData.subject || "No Subject",
      message: formData.message,
    };

    emailjs
      .send(
        "service_l81i5cj",
        "template_dt9ggqj",
        emailParams,
        "-QNL2jE1uJKEUyxmb"
      )
      .then(
        () => {
          setSuccessMessage("Your message has been sent successfully!");
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            subject: "",
            message: "",
          });
          setRecaptchaToken(null);
        },
        () => {
          setErrorMessage(
            "An error occurred while sending your message. Please try again."
          );
        }
      );
  };

  return (
    <>
      <div className="contact-page">
        <div className="contact-page__container">
          <Navbar />
          <div className="contact-body">
            <h2 className="contact-tagline">
              lets craft something unforgettable <br />
              together
            </h2>
            <div className="contact-intro">
              <p>
                I’m a 23-year-old freelance filmmaker with a master’s degree in
                filmmaking and over five years of hands-on experience in
                commercial fashion and automobile films. My passion lies in
                blending elite aesthetics with a touch of retro flair to craft
                projects that stand out and resonate. Beyond the screen, I delve
                into documentary storytelling and photography, capturing
                timeless narratives and visuals that linger long after the
                frame. Whether it’s a sleek automobile cruising through scenic
                landscapes or a fashion story elevated by cinematic charm, I aim
                to create work that inspires and connects. Let’s create stories
                together that leave a lasting mark—stories that are as
                unforgettable as the moments they capture.
              </p>
            </div>

            <div className="contact-sections">
              <div className="contact-left">
                <h2>Let's Talk</h2>
                <hr />
                <p>
                  <FaEnvelope style={{ width: "25px", height: "auto" }} />{" "}
                  <a href="mailto:augustsautumnmediaworks@gmail.com">
                    augustsautumnmediaworks@gmail.com
                  </a>
                </p>
                <p>
                  {/* <FaPhoneAlt />  */}
                  <Flag
                    code="GB"
                    style={{ width: "25px", height: "auto" }}
                  />{" "}
                  <a href="tel:+447473245363">+44 7473 245363</a>
                </p>
                <p>
                  {/* <FaPhoneAlt />  */}
                  <Flag
                    code="IN"
                    style={{ width: "25px", height: "auto" }}
                  />{" "}
                  <a href="tel:+918433168281">+91 84331 68281</a>
                </p>
                <p>
                  <FaInstagram style={{ width: "25px", height: "auto" }} />{" "}
                  <a
                    href="https://www.instagram.com/augusts_autumn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    augusts_autumn
                  </a>
                </p>
              </div>

              <div className="contact-right">
                <h2>You Can Also Leave a Message Here</h2>
                <hr />
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label>First Name *</label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Subject</label>
                    <input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group full-width">
                    <label>Message *</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="recaptcha-submit">
                    <ReCAPTCHA
                      sitekey="6LfIiKcqAAAAANrW7n0nBp4ceI7_bSBjHoMqj-ex"
                      onChange={handleRecaptchaChange}
                      theme="dark"
                      // size="invisible"
                    />
                    <button type="submit" className="submit-button">
                      Submit
                    </button>
                  </div>
                  {errorMessage && (
                    <p className="error-message">{errorMessage}</p>
                  )}
                  {successMessage && (
                    <p className="success-message">{successMessage}</p>
                  )}
                </form>
              </div>
            </div>
            <p className="excited-message">Excited to hear from you</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Contact;
